module.exports = __webpack_public_path__ + "img/icon.2194d499.svg";